export default "__VITE_ASSET__BSzznOvT__"